var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgElk = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 172,
    viewBox: "0 0 191 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3CEC4",
    fillRule: "evenodd",
    d: "M157.968 36.38C143.475.277 63.943-26.207 31.927 48.82-.09 123.85 25.215 83.033 3.77 128.093c-21.444 45.061 70.11 57.868 146.722 26.533 76.611-31.334 21.969-82.144 7.476-118.246z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgElk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/elk.31ab3fe6.svg";
export { ForwardRef as ReactComponent };